import { TEAM_MENTION_PREFIX } from "@mapmycustomers/shared/util/consts";

export const MENTION_LETTER_OFFSET = 24;

const USER_MENTION_REGEXP = /(@([^Q\s]+@\S+))/g;

export const MENTIONS_REGEXP = new RegExp(
  `(?<user>${USER_MENTION_REGEXP.source})|${TEAM_MENTION_PREFIX}(?<team>\\d+)`,
  "g"
);
